// extracted by mini-css-extract-plugin
export default {"label":"motivation-tile-module__label--MjR","selected":"motivation-tile-module__selected--Ywh","text":"motivation-tile-module__text--V84"};